import { textItems } from './shared';

export const h2 = {
  title: 'H2',
  ...textItems,
  styles: {
    ...textItems.styles,
    fontSize: '22px',
  },
};
